
window.showSpinner = function() {
	document.getElementById('spinner').style.display = 'inline';
}

window.hideSpinner = function() {
	document.getElementById('spinner').style.display = 'none';
}

window.handleUnauthenticated = function() {
	window.location = '/';
}

